import React, { useEffect } from "react";
import { YhPageHeader } from "@/components/YhPageHeader";
import { InfoBox } from "./InfoBox";
import { ActionTypeEnum, useDetailModel } from "./detailModel";

import { AccountSearchBox } from "./account/SearchBox";                 // 账户列表检索区
import { AdjustSearchBox } from "./adjust/SearchBox";                   // 调额记录检索区
import { BIllSearchBox } from "./bill/SearchBox";                       // 账单列表检索区
import { LogSearchBox } from "./log/SearchBox";                         // 操作日志检索区
import { RechargeSearchBox } from "./recharge/SearchBox";               // 充值记录检索区
import { TransferSearchBox } from "./transfer/SearchBox";               // 转账记录检索区
import { WriteoffSearchBox } from "./writeoff/SearchBox";               // 核销记录检索区

import { AccountDataBox } from "./account";                             // 账户列表展示区
import { AdjustDataBox } from "./adjust";                               // 调额记录展示区
import { BillDataBox } from "./bill";                                   // 账单列表展示区
import { LogDataBox } from "./log";                                     // 操作日志展示区
import { RechargeDataBox } from "./recharge";       
import { ReceivableDataBox } from "./receivable";                        // 充值记录展示区
import { TransferDataBox } from "./transfer";                           // 转账记录展示区
import { WriteoffDataBox } from "./writeoff";                           // 核销记录展示区
import { orgService } from "../../../../base/org/orgService";
import { dictService } from "../../../../base/dict/dictService";
import { beService } from "../../../../base/be/beService";
import { labelsType } from "../../../../cash/pay/cashPayModel";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { useGlobalModel } from "@/model/globalModel";
import { OptionDsType } from "@/types/FmsTypes";

/**
 * 检索区判断
 */
const DetailSearchBox = () => {
    const { actionType, } = useDetailModel();
    switch (actionType) {
        case ActionTypeEnum.ACCOUNT:
            return <AccountSearchBox />;
        case ActionTypeEnum.ADJUST_LIST:
            return <AdjustSearchBox />;
        case ActionTypeEnum.BILL_LIST:
            return <BIllSearchBox />;
        case ActionTypeEnum.LOG_LIST:
            return <LogSearchBox />;
        case ActionTypeEnum.RECHARGE_LIST:
            return <RechargeSearchBox />;
        case ActionTypeEnum.TRANSFER_LIst:
            return <TransferSearchBox />;
        case ActionTypeEnum.WRITEOFF_LIST:
            return <WriteoffSearchBox />;
        default:
            return <></>
    }
}

/**
 * 内容区判断
 */
const DetailDataBox = () => {
    const { actionType, } = useDetailModel();
    switch (actionType) {
        case ActionTypeEnum.ACCOUNT:
            return <AccountDataBox />;
        case ActionTypeEnum.ADJUST_LIST:
            return <AdjustDataBox />;
        case ActionTypeEnum.BILL_LIST:
            return <BillDataBox />;
        case ActionTypeEnum.LOG_LIST:
            return <LogDataBox />;
        case ActionTypeEnum.RECHARGE_LIST:
            return <RechargeDataBox />;
        case ActionTypeEnum.TRANSFER_LIst:
            return <TransferDataBox />;
        case ActionTypeEnum.WRITEOFF_LIST:
            return <WriteoffDataBox />;
        case ActionTypeEnum.SYSTEM_RECEIVABLE:
            return <ReceivableDataBox />;
        default:
            return <></>
    }
}

export const CustomerAccountDetail = () => {
    const {
        setOrgDs,
        setBeDs,
        setPayMethodLabels,
        setAppDs,
        setPayMethodDs,
        setAccountType,
        customerCode, setActionType,
        closeNav,
        loadSummaryData,
    } = useDetailModel();

    const { resourceAuth, getSelectedDict, appDs } = useGlobalModel(model => [model.resourceAuth, model.appDs]);

    useEffect(() => {
        let obj: labelsType = {};
        orgService.orgTreeDs({}).then(ds => { setOrgDs(ds) })
        beService.beDs({}).then(ds => setBeDs(ds))
        dictService.accountTreeOne(DictCodeEnmu.PAY_METHOD).then(ds => setPayMethodDs(ds))

        setAppDs(appDs);
        dictService.dictItemDs(DictCodeEnmu.ACC_TYPE).then(ds => {
            setAccountType(ds)
        })
        // setAccountType(() => getSelectedDict(DictCodeEnmu.ACC_TYPE) as OptionDsType[])
        getSelectedDict(DictCodeEnmu.SETTLE_TYPE).forEach(item => {
            obj[item.value] = item.label
        })
        setPayMethodLabels(obj);
        //进入详情， 会去查有没有分配权限， 并取到第一个权限为展示
        setActionType(origin => {
            if (origin !== ActionTypeEnum.NULL) return origin;
            //所有tab权限
            let authArr = [
                ResourceAuthEnum.ACC_C_VW_AC,
                ResourceAuthEnum.ACC_C_VW_ADJ,
                ResourceAuthEnum.ACC_C_VW_CHARG,
                ResourceAuthEnum.ACC_C_VW_TRANS,
                ResourceAuthEnum.ACC_C_VW_BILL,
                ResourceAuthEnum.ACC_C_VW_W_OFF,
                ResourceAuthEnum.ACC_C_VW_LOG,
            ];
            //过滤出来所有分配的权限；
            let findAuth = resourceAuth.filter(item => authArr.indexOf(item as ResourceAuthEnum) >= 0);
            if (!findAuth.length) return ActionTypeEnum.NULL;
            if (findAuth.indexOf(ResourceAuthEnum.ACC_C_VW_AC) > 0) return ActionTypeEnum.ACCOUNT;
            switch (findAuth[0]) {
                case ResourceAuthEnum.ACC_C_VW_AC:
                    return ActionTypeEnum.ACCOUNT;
                case ResourceAuthEnum.ACC_C_VW_ADJ:
                    return ActionTypeEnum.ADJUST_LIST;
                case ResourceAuthEnum.ACC_C_VW_CHARG:
                    return ActionTypeEnum.RECHARGE_LIST;
                case ResourceAuthEnum.ACC_C_VW_TRANS:
                    return ActionTypeEnum.TRANSFER_LIst;
                case ResourceAuthEnum.ACC_C_VW_BILL:
                    return ActionTypeEnum.BILL_LIST;
                case ResourceAuthEnum.ACC_C_VW_W_OFF:
                    return ActionTypeEnum.WRITEOFF_LIST;
                case ResourceAuthEnum.ACC_C_VW_LOG:
                    return ActionTypeEnum.LOG_LIST;
                default:
                    return ActionTypeEnum.NULL;
            }
        });
        if (!customerCode) {
            return closeNav("2-4-1");
        };
    }, []);

    useEffect(() => {
        loadSummaryData()
    }, [customerCode]);

    return (
        <>
            <YhPageHeader title="客户账户详情" />
            <InfoBox />
            <DetailSearchBox />
            <DetailDataBox />
        </>
    )
}
